import React from 'react'
import moment from 'moment'
import { slice } from 'lodash'

import { calendarCellHeadingsDateFormat as configDateFormat } from '../../../configuration/configs'

const CalendarWeekDays = ({ currentDate }) => {
  const weekDays = []
  let startDate = moment(currentDate).startOf('week')

  function formattedWeekday(i) {
    return configDateFormat === 'single-letter'
      ? slice(moment(startDate).add(i, 'days').format('dd'), 0, 1)
      : moment(startDate).add(i, 'days').format(configDateFormat)
  }

  for (let i = 0; i < 7; i++) {
    weekDays.push(
      <div className="day-wrapper" key={i}>
        <span className="day">{formattedWeekday(i)}</span>
      </div>
    )
  }

  return <div className="u-calendar__days">{weekDays}</div>
}

export default CalendarWeekDays
